<template>
	<div class="d_flex">
		<!-- Menu Area -->
		<div class="side_menu">
			<h2 class="mb_30">{{ $t('rtr_development-developmain.text12') }}</h2>
			<ul class="left_content" ref="leftContent">
				<li
					v-for="(item, idx) in menuItems"
					:key="item"
					:class="{ active: selectedMenuIdx === idx }"
				>
					<a :href="`#${item.id}`" @click.prevent="toSection(idx)">{{
						item.value
					}}</a>
				</li>
			</ul>
		</div>
		<!-- Inner Area-->
		<div class="content_inner">
			<div class="inner_wrap">
				<div class="title">
					<h1 class="mb_20">{{ $t('rtr_development-developmain.text1') }}</h1>
					<p>{{ $t('rtr_development-developmain.text2') }}</p>
				</div>

				<section ref="section1" id="section1">
					<h2 class="mb_20">{{ $t('rtr_development-developmain.text15') }}</h2>
					<div class="develop_box_wrap">
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">
								{{ $t('rtr_development-developmain.text3') }}
							</h4>
							<p class="mb_16">{{ $t('rtr_development-developmain.text4') }}</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">
								{{ $t('rtr_development-developmain.text5') }}
							</h4>
							<p class="mb_16">
								{{ $t('rtr_development-developmain.text6') }}
							</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">
								{{ $t('rtr_development-developmain.text7') }}
							</h4>
							<p class="mb_16">
								{{ $t('rtr_development-developmain.text8') }}
							</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mb_0">
							<div class="round"></div>
							<h4 class="mb_10">
								{{ $t('rtr_development-developmain.text9') }}
							</h4>
							<p class="mb_16">
								{{ $t('rtr_development-developmain.text16') }}
							</p>
							<!--							<button class="red">button</button>-->
						</div>
					</div>
				</section>

				<!-- tab type -->
				<section ref="section2" id="section2">
					<div class="card tab_type">
						<div class="d_flex mb_20 align_items_center step">
							<span>{{ $t('rtr_development-developmain.text35') }}</span>
							<h3>{{ $t('rtr_development-developmain.text10') }}</h3>
						</div>
						<div class="border_box">
							<h3 class="mb_10">
								{{ $t('rtr_development-developmain.text20') }}
							</h3>
							<p>{{ $t('rtr_development-developmain.text11') }}</p>
							<ul class="list">
								<li>{{ $t('rtr_development-developmain.text17') }}</li>
								<li>{{ $t('rtr_development-developmain.text18') }}</li>
								<li>{{ $t('rtr_development-developmain.text19') }}</li>
							</ul>
						</div>
						<!-- tab -->
						<ul class="tab_area mb_0">
							<li :class="{ selected: selectedTab === 1 }">
								<a class="tab_item" @click="tabSelect(1)">
									<span>{{ $t('rtr_development-developmain.text21') }}</span></a
								>
							</li>
							<li :class="{ selected: selectedTab === 2 }">
								<a class="tab_item" @click="tabSelect(2)">
									<span>{{ $t('rtr_development-developmain.text22') }}</span></a
								>
							</li>
							<li :class="{ selected: selectedTab === 3 }">
								<a class="tab_item" @click="tabSelect(3)">
									<span>{{ $t('rtr_development-developmain.text23') }}</span></a
								>
							</li>
							<li :class="{ selected: selectedTab === 4 }">
								<a class="tab_item" @click="tabSelect(4)">
									<span>{{ $t('rtr_development-developmain.text24') }}</span></a
								>
							</li>
						</ul>

						<div class="tab_content">
							<div v-if="selectedTab === 1">
								<table>
									<colgroup>
										<col style="width: 20%" />
										<col />
										<col style="width: 25%" />
									</colgroup>
									<tbody>
										<tr>
											<th>{{ $t('rtr_development-developmain.text25') }}</th>
											<td>{{ $t('rtr_development-developmain.text26') }}</td>
											<td>
												<div class="tag_area">
													<div class="tag blue">
														{{ $t('rtr_development-developmain.text27') }}
													</div>
													<div class="tag green">
														{{ $t('rtr_development-developmain.text28') }}
													</div>
													<div class="tag">
														{{ $t('rtr_development-developmain.text29') }}
													</div>
												</div>
											</td>
										</tr>
										<tr>
											<th>{{ $t('rtr_development-developmain.text30') }}</th>
											<td>{{ $t('rtr_development-developmain.text31') }}</td>
											<td>
												<div class="tag_area">
													<div class="tag yellow">
														{{ $t('rtr_development-developmain.text32') }}
													</div>
													<div class="tag green">
														{{ $t('rtr_development-developmain.text33') }}
													</div>
													<div class="tag">
														{{ $t('rtr_development-developmain.text34') }}
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</section>

				<!-- info type -->
				<!--				<section ref="section3" id="section3">-->
				<!--					<div class="card mb_30 info_type">-->
				<!--						<h3 class="mb_10">Title</h3>-->
				<!--						<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--						<div class="mt_30">-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img src="@/assets/images/development/check.png" alt="" />-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img src="@/assets/images/development/check.png" alt="" />-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img-->
				<!--											src="@/assets/images/development/check.png"-->
				<!--											alt="checked icon"-->
				<!--										/>-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<table class="table_type">-->
				<!--										<colgroup>-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--										</colgroup>-->
				<!--										<thead>-->
				<!--											<tr>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--											</tr>-->
				<!--										</thead>-->
				<!--										<tbody>-->
				<!--											<tr>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--											</tr>-->
				<!--											<tr>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--											</tr>-->
				<!--										</tbody>-->
				<!--									</table>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--						</div>-->
				<!--					</div>-->
				<!--				</section>-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DevelopMain.vue',
	data() {
		return {
			selectedTab: 1,
			selectedMenuIdx: 0,
			menuItems: [
				{
					id: 'section1',
					value: this.$t('rtr_development-developmain.text13'),
				},
				{
					id: 'section2',
					value: this.$t('rtr_development-developmain.text14'),
				},
				// {
				// 	id: 'section3',
				// 	value: 'Section 03',
				// 	isActive: false,
				// },
				// {
				// 	id: 'section4',
				// 	value: 'Section 04',
				// 	isActive: false,
				// },
				// {
				// 	id: 'section5',
				// 	value: 'Section 05',
				// 	isActive: false,
				// },
			],
		};
	},
	computed: {
		selectMenuItem() {
			return this.menuItems[this.selectedMenuIdx];
		},
	},
	methods: {
		tabSelect(e) {
			this.selectedTab = e;
		},
		toSection(idx) {
			this.selectedMenuIdx = idx;
			const targetEl = this.$refs[this.selectMenuItem.id];
			this.$smoothScroll({
				scrollTo: targetEl,
				updateHistory: false,
				offset: -100,
			});
		},
		scrollEvents() {
			const menuItems = this.menuItems;
			menuItems.forEach((item, idx) => {
				const sectionEl = this.$refs[item.id];
				const sectionTop = sectionEl.offsetTop;
				const sectionHeight = sectionEl.clientHeight;
				if (scrollY >= sectionTop - sectionHeight) {
					this.selectedMenuIdx = idx;
				}
			});
		},
	},
	mounted() {
		document.addEventListener('scroll', () => {
			let timer;
			if (!timer) {
				timer = setTimeout(() => {
					timer = null;
					this.scrollEvents();
				}, 400);
			}
		});
	},
	unmounted() {
		document.removeEventListener('scroll', this.scrollEvents);
	},
};
</script>
